var Footer = {
    init:function(){
        console.log("FOOTER INIT");

        document.querySelectorAll(".footer__content-top .menu .menu__title").forEach(function(item, i){
            item.addEventListener("click", function(){
                Footer.change_carousel(i);
            })
        });
    },
    change_carousel:function(id){
        console.log("OPEN CAROUSEL : " + id);
        document.querySelectorAll(".footer__content-top .menu").forEach(function(item, i){
            if(i == id){
                if(item.classList.contains("open")){
                    Footer.close_item(item);
                }else{
                    Footer.open_item(item);
                }
            }else{
                Footer.close_item(item);
            }
        });
    },
    open_item:function(item){
        var _h_dest = item.querySelector(".menu__links").offsetHeight;
        console.log("H DEST : " + _h_dest);
        item.classList.add("open");
        
        item.querySelector(".menu__links-container").style.height = _h_dest + "px";
    },
    close_item:function(item){
        item.classList.remove("open");
        item.querySelector(".menu__links-container").style.height = 0;
    }
}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".footer").length > 0){
        Footer.init();
    }
})